import { render, staticRenderFns } from "./warehouseAddress.vue?vue&type=template&id=012bf7ab&scoped=true&"
import script from "./warehouseAddress.vue?vue&type=script&lang=js&"
export * from "./warehouseAddress.vue?vue&type=script&lang=js&"
import style0 from "./warehouseAddress.vue?vue&type=style&index=0&id=012bf7ab&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "012bf7ab",
  null
  
)

export default component.exports